import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PreDeliveryInspectionLocationWithLogin from "./component";
import { createPDILead, fetchLeadDetails, fetchSlots, updatePDILead } from "../pre-delivery-inspection/actions";
import { setPosition } from "../../location/actions";
import withOtpDesktop from "../with-otp-desktop";
import usePdiAppointmentLogin from "../../../hooks/use-login";
import { withRouter } from "react-router";

const mapStateToProps = ({
    preDeliveryInspectionLeadData: { brand, model, registrationNumber, token: leadToken, newCarPdiLead, intent },
    user: { isLoggedIn, mobile, secureToken}
}) => ({
    isLoggedIn,
    mobile,
    brand,
    model,
    secureToken,
    registrationNumber,
    leadToken,
    newCarPdiLead,
    intent,
    pageType: "pre-delivery-inspection"
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchLeadDetailsConnect: fetchLeadDetails,
    setPositionConnect: setPosition,
    fetchSlotsConnect: fetchSlots,
    createPDILeadConnect: createPDILead,
    updatePDILeadConnect: updatePDILead
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withOtpDesktop(PreDeliveryInspectionLocationWithLogin)(usePdiAppointmentLogin)));
